import React, { useContext } from "react";
import SurveyFormItem, { SurveyFormItemProps } from "../SurveyFormItem/SurveyFormItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core';
import './SurveyFormContentItem.css';
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIconOption } from "../../../IconPicker/IconPicker";
import classNames from "classnames";
import { SurveyStepContext } from "../../Util/surveyStepContext";
import { designSurveyItem } from "../../Util/useDesignerSelectedFormItem";
import { getDesignModeStepType } from "../../Util/surveyStepUtils";

export interface SurveyFormContentItemProps extends SurveyFormItemProps {
    backgroundStyle?: null | "Card";
    icon?: FontAwesomeIconOption | null;
    contentItemSettings: Record<string,string>;
}

export default function SurveyFormContentItem(props: SurveyFormContentItemProps) {
    let surveyStepContext = useContext(SurveyStepContext)!;

    library.add(far);
    library.add(fas);

    const bg = props.contentItemSettings['iconBackground'];
    const showBg = bg === 'Circle' || !bg;
    const bgColor = showBg ? props.contentItemSettings['iconBackgroundColor'] : 'transparent';
    const bgColorDark = showBg ? props.contentItemSettings['iconBackgroundColorDark'] : 'transparent';
    const size = props.contentItemSettings['iconSize'];

    const iconClasses = {
        'circle': bg === 'Circle' || !bg,
        'medium': size === 'Medium' || !size,
        'large': size === 'Large'
    };

    const alignmentClass = props.contentItemSettings['iconAlignment'] === "Middle" ? 'survey-form-content-middle-align' : 'survey-form-content-top-align';

    function selectFormItemForDesigner() {
        const designModeStepType = getDesignModeStepType(surveyStepContext.stepDefinition);
        if (
            surveyStepContext.mode === "Design" &&
            (
                designModeStepType == "FormStep" ||
                designModeStepType == "InstructionStep" ||
                designModeStepType == "ConsentFormStep"
            ) &&
            props.index != undefined
        ) {
            designSurveyItem({ stepIndex: surveyStepContext.surveyDefinition.steps.indexOf(surveyStepContext.stepDefinition), formItemIndex: props.index });
        }
    }

    let classes = [
        "survey-form-content", 
        alignmentClass, 
        `survey-form-content-${props.backgroundStyle?.toLowerCase() || "standard"}`
    ];

    return <div onClick={(event) => { event.stopPropagation(); selectFormItemForDesigner(); } } className={classNames(classes)}>
        {props.icon &&
            <div 
                className={ classNames(
                    "survey-form-content-icon", 
                    iconClasses
                )} 
                style={{
                    backgroundColor: bgColor,
                    color: props.contentItemSettings['iconColor'],
                    ["--content-item-icon-dark" as any]: props.contentItemSettings['iconColorDark'],
                    ["--content-item-icon-background-dark" as any]: bgColorDark
                }}>
                {props.icon.prefix && props.icon.value &&
                    <FontAwesomeIcon icon={[ props.icon.prefix, props.icon.value]} />
                }
            </div>
        }
        <SurveyFormItem
            label={props.label}
            variant={props.variant}
            useFieldsetFormat={props.useFieldsetFormat}
            index={props.index}>
            <></>
        </SurveyFormItem>
    </div>;
}